<template>
  <vue-html2pdf
    class="wrapper-up"
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    ref="html2Pdf"
    :preview-modal="true"
    :paginate-elements-by-height="1400"
    :filename="'incident_blank_'"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="landscape"
    @progress="onProgress($event)"
    @hasStartedGeneration="hasStartedGeneration($event)"
    @hasGenerated="hasGenerated($event)"
  >
    <!--                  pdf-content-width="800px"-->

    <!--        Content        -->
    <section slot="pdf-content">
      <slot />
    </section>

    <button class="btn btn-primary">Download</button>
  </vue-html2pdf>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'LayoutDefault',
  components: { VueHtml2pdf },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    hasGenerated(e) {
      console.log(e);
    },
    hasStartedGeneration(e) {
      console.log(e);
    },
    onProgress(e) {
      console.log(e);
    }
  }
};
</script>
